import { z } from "zod";
export const schemaDeviceType = z.enum([
    "blue",
    "nanoS",
    "nanoSP",
    "nanoX",
    "stax",
]);
//# sourceMappingURL=Device.js.map